import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

type Props = object;
export const FloatingImage = styled.img<PropsWithChildren<Props>>`
  position: fixed;
  left: 0;
  width: calc(300px + 25vh);
  height: calc(300px + 25vh);
  max-width: calc(100% - 40px);
  z-index: -5;
`;
export const FloatingIcon = styled.div<PropsWithChildren<Props>>`
  position: fixed;
  left: 0;
  width: calc(300px + 25vh);
  height: calc(300px + 25vh);
  font-size: calc(300px + 25vh);
  max-width: calc(100% - 40px);
  z-index: -5;
  ${({ theme }) => theme.breakpoints.up('xl')} {
    left: calc(50% - 50vw);
  }
`;
